export const purpurSpacing0 = "0rem";
export const purpurSpacing10 = "0.0625rem";
export const purpurSpacing25 = "0.125rem";
export const purpurSpacing50 = "0.25rem";
export const purpurSpacing100 = "0.5rem";
export const purpurSpacing150 = "0.75rem";
export const purpurSpacing200 = "1rem";
export const purpurSpacing250 = "1.25rem";
export const purpurSpacing300 = "1.5rem";
export const purpurSpacing400 = "2rem";
export const purpurSpacing600 = "3rem";
export const purpurSpacing800 = "4rem";
export const purpurSpacing1000 = "5rem";
export const purpurSpacing1200 = "6rem";
export const purpurSpacing1600 = "8rem";
export const purpurSpacingGutterSm = "1rem";
export const purpurSpacingGutterMd = "1.5rem";
export const purpurSpacingGutterLg = "1.5rem";
export const purpurSpacingGutterXl = "1.5rem";
export const purpurSpacingPagePaddingSm = "1rem";
export const purpurSpacingPagePaddingMd = "1.5rem";
export const purpurSpacingPagePaddingLg = "3rem";
export const purpurSpacingPagePaddingXl = "3rem";
